module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_6000.e5c65edd.png";